import InfoIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';
import { CLICK_TO_VIEW_ERROR_DETAILS } from '../../content';
import { IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface ErrorIconProps {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
  onMouseLeave?: () => void;
  size?: 'small' | 'medium' | 'large';
  tooltip?: string;
}

const useStyles = makeStyles(() => ({
  errorIcon: {
    color: 'red',
    cursor: 'pointer',
    fontSize: '16px',
    padding: '2px',
  },
}));

/**
 * Reusable Error Icon component for displaying export errors
 * Shows a red warning icon that can be clicked to show error details
 */
const ErrorIcon: React.FC<ErrorIconProps> = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  tooltip = CLICK_TO_VIEW_ERROR_DETAILS,
}) => {
  const classes = useStyles();

  return (
    <Tooltip title={tooltip} arrow placement="top">
      <IconButton
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        size="small"
        className={classes.errorIcon}
        aria-label="View error details"
      >
        <InfoIcon style={{ fontSize: '20px' }} />
      </IconButton>
    </Tooltip>
  );
};

export default ErrorIcon;
